/**
 * The invitation that is waiting in THIS browser tab.
 *
 * Two pages need to agree about it — /join, which puts the token there, and
 * the login page, which has to know where to send the person back to after a
 * real sign-in — so the key and the path live here once rather than being
 * spelled out in both. (CLAUDE.md: the recurring failure in this codebase is
 * forked copies of one rule.)
 */

/** sessionStorage key: this tab only, cleared the moment the token is spent. */
export const INVITE_TOKEN_KEY = 't06.invite.token';

/**
 * The ONLY path the invitation flow returns to. A CONSTANT, deliberately:
 * taken from a query parameter it would make the login page an open redirect.
 */
export const JOIN_PATH = '/join';

/**
 * Is an invitation still waiting in this tab?
 *
 * This is the DURABLE half of "come back to /join after signing in". Router
 * state cannot carry it: `loginRedirect` leaves the SPA entirely and returns
 * to `/`, so anything held in memory is gone by then. The token is already in
 * sessionStorage for exactly the same reason, and sessionStorage survives a
 * redirect within the same tab.
 *
 * Returns false rather than throwing where storage is blocked (private mode),
 * which simply means the person lands on the default page instead.
 */
export function hasPendingInvite(): boolean {
  try {
    return Boolean(window.sessionStorage.getItem(INVITE_TOKEN_KEY));
  } catch {
    return false;
  }
}
